/**
 * Calm Under Fire: your aim tightens as your health goes.
 *
 * Backwards on purpose. Every other system in the game punishes being hurt, so one perk that pays
 * out there turns the worst thirty seconds of a raid into a decision instead of a retreat.
 */

import type { Perk } from '@/sim/progression/perkContract';

export const CALM_UNDER_FIRE = {
  id: 'calmUnderFire',
  branch: 'gunplay',
  tier: 2,
  title: 'Calm Under Fire',
  blurb: 'Panic is a choice. Halcyon thanks you for choosing otherwise.',
  maxRanks: 3,
  minLevel: 9,
  requires: ['steadyHands'],
  statGrants: {},
  effects: [{ field: 'weaponSpread', perRank: -0.09, condition: 'whileHurt' }],
  damageModifiers: [],
} as const satisfies Perk;
